<template>
    <div>
        <ui-modal v-ref:modal :width="1000" style="color: rgba(0, 0, 0, .5)">
            <div style="padding: 20px">
                <h2 class="text-center" style="margin-bottom: 60px">
                    O que você deseja cadastrar?
                </h2>

                <div class="row">
                    <div class="col-md-4 col">
                        <img class="icon" src="/assets/images/house.svg"/>
                        <div class="title">Imóvel</div>
                        <div class="subtitle">Casas, aptos, terrenos, imóveis comerciais, industriais, sítios, chácaras e fazendas.</div>
                        <div class="final">
                            <a href="/properties/add" class="btn orange btn-block">
                                Cadastrar
                                <i class="fa fa-arrow-circle-right"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-4 col">
                        <img class="icon" src="/assets/images/building.svg"/>
                        <div class="title">Empreendimentos</div>
                        <div class="subtitle">Pré-lançamentos, imóveis na planta, unidades remanescentes e outros.</div>
                        <div class="final">
                            <div class="simple-flex-row">
                                <div class="remove-form-group-margin">
                                    <form-remote-select v-ref:building-select
                                                        :model.sync="building_id"
                                                        url="/buildings"
                                                        :query="{type: 2, sort: {updated_at: null, draft: null, name: 'asc'}, presenter: 'simple-presenter'}"
                                                        :template-result="formatBuildingResult('Selecione o empreedimento')"
                                                        :template-selection="formatBuildingSelection('Selecione o empreedimento')"
                                                        :on-prefetched="buildingSelected"
                                                        :process-result="processBuildingsResult"
                                                        :has-label="false"
                                                        placeholder="Selecione o empreedimento">
                                    </form-remote-select>
                                </div>
                                <div style="width: 40px; flex-shrink: 0">
                                    <button type="button" class="btn orange" @click="goToBuilding()">
                                        <i class="fa fa-arrow-circle-right"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="text-center" style="margin-top: 5px; font-size: 12px;">
                                ou
                                <a href="/buildings/add">cadastrar novo <b>empreendimento</b></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col">
                        <img class="icon" src="/assets/images/houses.svg"/>
                        <div class="title">Imóveis em Condomínio</div>
                        <div class="subtitle">Casas, terrenos em condomínios fechados.</div>
                        <div class="final">
                            <div class="simple-flex-row">
                                <div class="remove-form-group-margin">
                                    <form-remote-select v-ref:building-select
                                                        :model.sync="condominium_id"
                                                        url="/buildings"
                                                        :query="{type: 1, sort: {updated_at: null, draft: null, name: 'asc'}, presenter: 'simple-presenter'}"
                                                        :template-result="formatBuildingResult('Selecione o condomínio')"
                                                        :template-selection="formatBuildingSelection('Selecione o condomínio')"
                                                        :on-prefetched="buildingSelected"
                                                        :process-result="processBuildingsResult"
                                                        :has-label="false"
                                                        placeholder="Selecione o condomínio">
                                    </form-remote-select>
                                </div>
                                <div style="width: 40px; flex-shrink: 0">
                                    <button type="button" class="btn orange" @click="goToCondominium()">
                                        <i class="fa fa-arrow-circle-right"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="text-center" style="margin-top: 5px; font-size: 12px;">
                                ou
                                <a href="/condominiums/add">cadastrar novo <b>condomínio</b></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>
</template>
<style scoped>
    .col > .final > .simple-flex-row {
        margin-left: -5px;
        margin-right: -5px;
    }

    .col > .final > .simple-flex-row > div {
        margin-left: 5px;
        margin-right: 5px;
    }

    .col > .final > .simple-flex-row > div {
        flex-basis: auto;
        flex-grow: 1;
        overflow: hidden;
        width: 100%;
    }

    .row > .col {

    }

    .row > .col > .icon {
        width: 35%;
        margin: 0 auto;
        display: block;
        text-align: center;
    }

    .row > .col > .title {
        margin-top: 10px;
        font-weight: 600;
        font-size: 20px;
        text-align: center;
    }

    .row > .col > .subtitle {
        font-size: 13px;
        margin: 10px;
        text-align: center;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .row > .col > .final {
        margin: 24px 10px 10px;
    }
</style>
<script>
    export default {
        name: 'property-creation-modal',
        data () {
            return {
                building_id: null,
                condominium_id: null
            }
        },
        ready () {
        },
        methods: {
            show () {
                this.$refs.modal.show()
            },
            buildingSelected (id, building) {
            },
            processBuildingsResult (result, term) {
                return result
            },
            formatBuildingResult (placeholder) {
                return function (state, container) {
                    if (!state) {
                        return placeholder
                    }

                    return `<div>${state.name} - ${state.city.name}</div>`
                }
            },
            formatBuildingSelection (placeholder) {
                return function (state, container) {
                    if (!state) {
                        return placeholder
                    }

                    return `<div>${state.name} - ${state.city.name}</div>`
                }
            },
            goToBuilding () {
                if (this.building_id) {
                    window.location.href = `/buildings/${this.building_id}/towers`
                }
            },
            goToCondominium () {
                if (this.condominium_id) {
                    window.location.href = `/properties/add?building_id=${this.condominium_id}`
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CreationModal.vue?7b3deb86